import { useEffect } from "react";
import { X } from "lucide-react";

/**
 * Modal video player. Pass `video` (a VideoRef from the API) and `onClose`.
 * Plays inline, dim-backdrop, click-outside or Esc to close, native HTML5 controls.
 */
export default function VideoLightbox({ video, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  if (!video) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="video-lightbox"
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white grid place-items-center transition-colors"
        data-testid="video-lightbox-close"
      >
        <X className="w-5 h-5" />
      </button>
      <video
        src={video.url}
        poster={video.poster_url}
        controls
        autoPlay
        playsInline
        className="max-w-full max-h-[90vh] rounded-xl shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="video-lightbox-player"
      />
    </div>
  );
}
